import { CookieConsentService } from '@inter-ikea-kompis/services';
import { getKompisSettings } from '../services/kompisSettings';
import { getDexfSettings } from '../services/dexfSettingsService';
import { CookieConsentLevel } from '../analytics/enums/CookieConsentLevel';
import { isDevelopment, isKiosk } from '../utils/platform';
import { e2e } from '../utils/queryUtils';
const COOKIE_CONSENT_LEVELS = [
    CookieConsentLevel.technical,
    CookieConsentLevel.analytical,
    CookieConsentLevel.preference,
    CookieConsentLevel.marketing
];
export const getCookieConsentLevels = async () => {
    // Bypass cookie consent for kiosks, or in development (but not CTE)
    //   kiosks & e2e are not tied to individual personal information
    if (isKiosk() || isDevelopment() || e2e()) {
        return {
            [CookieConsentLevel.technical]: true,
            [CookieConsentLevel.analytical]: true
        };
    }
    const dexfSettings = await getDexfSettings();
    const kompisSettings = getKompisSettings(dexfSettings);
    const service = new CookieConsentService(kompisSettings);
    const consentLevels = {};
    await Promise.all(COOKIE_CONSENT_LEVELS.map(async (level) => {
        try {
            consentLevels[level] = await service.hasCookieConsent(level);
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error determining cookie consent for consent level ${level}`, error);
        }
    }));
    return consentLevels;
};
/**
 * Returns true if analytics is disabled.
 *
 * @return True if analytics is disabled.
 */
const hasAnalyticsDisabled = () => {
    // Never disable analytics during e2e tests
    if (e2e()) {
        return false;
    }
    return new URLSearchParams(window.location.search).get('noAnalyticsEvents') === 'true';
};
export const getAnalyticsConsentStatus = async () => {
    if (hasAnalyticsDisabled()) {
        return 'ANALYTICS DISABLED';
    }
    const cookieConsentLevels = await getCookieConsentLevels();
    if (cookieConsentLevels[CookieConsentLevel.analytical] === true) {
        return 'ANALYTICS ALLOWED';
    }
    return 'ANALYTICS NOT ALLOWED';
};
//# sourceMappingURL=getCookieConsentLevel.js.map